import { useEffect } from "react";
import authStore from "../stores/authStore";
import { useNavigate } from 'react-router-dom';

export default function LogoutPage() {
    const store = authStore();
    const navigate = useNavigate(); // this is a react hook

    useEffect(() => {
        store.logout();
        navigate("/login");
    }, []); // brackets to make it only run once when the page is rendered

    return (
        <div>
            <p>You've been logged out.</p>
        </div>
    );
}